




















































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography } from '@/components/atoms';
import ModalOptions from '@/components/Modal/ModalOptions';

import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import { pluralize } from '@/utils';

import PinIcon from '@/components/icons/Pin.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import CustomersIcon from '@/components/icons/Customers.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';
import TogglesIcon from '@/components/icons/Toggles.vue';
import InfoIcon from '@/components/icons/Info.vue';
import {
  TCustomerLimitType,
  TVisibilityType,
  TDeadLineType,
  Campaign
} from '@/models/marketingCenter/freeCoins';
import flagKeys from '@/constants/flagKeys';

type EditType = 'expiration' | 'customer';

@Component({
  components: {
    Surface,
    Typography,
    PinIcon,
    CoinsIcon,
    CustomersIcon,
    CalendarIcon,
    TogglesIcon,
    InfoIcon
  }
})
export default class CampaignSettingsOverview extends Vue {
  @Prop() coins?: string;
  @Prop() customerLimit?: number;
  @Prop() customerDailyLimit?: number;
  @Prop() customerLimitType?: TCustomerLimitType;
  @Prop() expiration?: string;
  @Prop() expirationType?: TDeadLineType;
  @Prop() immediateActivation?: boolean;
  @Prop({ default: false }) hideActivation?: boolean;
  @Prop({ default: false }) allowEdition?: boolean;
  @Prop() visibilityType?: TVisibilityType;
  @Prop() campaign?: Campaign;
  @Prop({ default: false }) isDetail?: boolean;

  get businessCities() {
    let locations: any = this.businessLocations;
    if (!locations) return [];

    locations = locations.map((location: any) => ({
      label: `${location.city}, ${location.state}`,
      locations: locations
        ? locations
            .filter(
              (loc: any) =>
                loc.city === location.city && loc.state === location.state
            )
            .map((loc: any) => ({
              label: `↪ ${loc.zip}, ${loc.address}`
            }))
        : []
    }));

    let locationInArray: any = [];

    return locations.filter((item: any) => {
      if (locationInArray.includes(item.label)) {
        return false;
      }
      locationInArray.push(item.label);
      return true;
    });
  }

  get businessLocations() {
    const { business } = this.$store.getters['business/getBusinessInfo'];

    if (!business || !business.businessLocations.length) {
      return [];
    }

    return business.businessLocations;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get coinsLabel() {
    if (!this.coins) {
      return 'No Coins defined';
    }

    return `${this.coins} ${pluralize(Number(this.coins), 'Coin')} per member`;
  }

  get customersLabel() {
    const labelMapper: Record<string, string> = {
      'total-customer': `${this.customerLimit || '-'} member limit`,
      'daily-customer': `${this.customerDailyLimit || '-'} daily member limit`,
      'no-limit': `No member limit`
    };

    return labelMapper[this.customerLimitType || 'default'];
  }

  get expirationLabel() {
    if (this.expiration && this.expirationType !== 'no-deadline') {
      const [date] = this.expiration.split('T');

      return DateUtils.formattedDate({ date });
    }

    return 'No expiration date';
  }

  get immediateActivationLabel() {
    if (this.immediateActivation) {
      return 'Start campaign after creation';
    }

    return 'Start campaign manually later';
  }

  edit(section: EditType) {
    const modalTypes: Record<EditType, string> = {
      expiration: 'offerFreeCoinsDeadlineEditModal',
      customer: 'offerFreeCoinsCustomerLimitEditModal'
    };

    if (!modalTypes[section]) return;

    const modalType = modalTypes[section];

    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        modalType,
        false,
        true,
        true,
        true,
        true
      ),
      { campaign: this.campaign, isDetail: this.isDetail }
    );
  }

  openLocationsModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'offerFreeCoinsLocationsModal',
        false,
        true,
        true,
        true,
        true
      ),
      { businessCities: this.businessCities }
    );
  }
}
